import { Box, Group, LoadingOverlay, TextInput } from "@mantine/core";
import { useState } from "react";
import {
  sendLinkedinInvitation,
  sendLinkedinMessage,
} from "../../../../../../../../api/WorkflowAPI";
import { notifications } from "@mantine/notifications";
import { useLanguage } from "../../../../../../../../stores/LanguageStore";
import LinkedinAccountSelector from "../../../../../../../../components/Selectors/LinkedinAccountSelector";
import LinkedinAnswerEditor from "./LinkedinAnswerEditor";

const AnswerSenderLinkedin = ({
  prospect,
  item,
  setAnswering,
  about,
  setProspectLoading,
  isInvitation,
  defaultSender = null,
  lastLinkedinReply
}) => {
  const lang = useLanguage((s) => s.language);
  const [sender, setSender] = useState(
    item?.reply_to?.integration_id
      ? { id: item?.reply_to?.integration_id, is_valid: true }
      : defaultSender
  );
  const [recipient, setRecipient] = useState(about?.linkedin_url || "");
  const [loading, setLoading] = useState(false);

  const [initialized, setInitialized] = useState(false);

  const handleInit = () => {
    setInitialized(true);
  };

  const handleSubmit = ({ text, file_id }) => {
    let newMessage = text;

    setLoading(true);

    const main = isInvitation ? sendLinkedinInvitation : sendLinkedinMessage;
    main({
      contact_id: prospect.id,
      integration_id: sender?.id,
      message: newMessage,
      file_id: file_id,
    })
      .then((res) => {
        notifications.show({
          message: isInvitation
            ? lang.leads.invitation_sent
            : lang.leads.message_sent,
          color: "green.8",
        });
        setAnswering(false);

        setProspectLoading(true);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Box
      pos={"relative"}
      p="md"
      style={{ borderRadius: 8 }}
      h={"auto"}
      bg={"#fff"}
    >
      <LoadingOverlay visible={loading || !initialized} />

      {initialized && (
        <Group
          w={"100%"}
          wrap="nowrap"
          gap={"lg"}
          px={8}
          pl={4}
          pt={4}
          pos={"relative"}
          pb={16}
          style={{
            zIndex: 4,
          }}
          align="start"
        >
          <TextInput
            type="url"
            value={recipient}
            onChange={(e) => setRecipient(e.target.value)}
            label={lang.leads.contact_linkedin}
            placeholder={"https://www.linkedin.com/in/"}
            w={"100%"}
            required
            error={
              recipient !== about.linkedin_url ? lang.leads.linkedin_diff : null
            }
          />
          <LinkedinAccountSelector
            label={lang.leads.account}
            size={"sm"}
            required
            onChange={setSender}
            value={sender?.id}
            withPool={false}
          />
        </Group>
      )}

      <LinkedinAnswerEditor
        key={item?.id}
        id={item?.id}
        handleSubmit={handleSubmit}
        handleClose={() => setAnswering(false)}
        onInit={handleInit}
        loading={loading}
        disabled={!sender || !recipient}
        isInvitation={isInvitation}
        lastLinkedinReply={lastLinkedinReply}
      />
    </Box>
  );
};

export default AnswerSenderLinkedin;
